import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { TransactionSearchResultDto } from 'api/Search/Types/SearchResultDto'
import { Link } from 'components/Link'

export const TransactionColumnDefinition: GridColumnProps[] = [
  {
    title: 'Name',
    cell: (props: GridCellProps): JSX.Element => {
      const data = props.dataItem as TransactionSearchResultDto
      if (!data.value) {
        return <td />
      }
      if (!data.id) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath('/transactions/:id', {
                id: props.dataItem.id,
              }),
            }}
          >
            {data.value}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Group Reference',
    field: 'data.groupReference.name',
  },
  {
    title: 'Type',
    field: 'data.transactionType.name',
  },
  {
    title: 'State',
    field: 'data.transactionState.name',
  },
]
